var $body = $("body"),
  $doc = $(document),
  $html = $("html"),
  $win = $(window);

// Define the function separately to enable removal later
function handleTabClick(event) {
  event.preventDefault();
  event.stopPropagation();
  const tabs = document.querySelectorAll(".custom-tab .tab-title");
  const tabContents = document.querySelectorAll(".custom-tab .tab-content");
  const $this = event.target;
  const id = $this.getAttribute("href").replace("#", "");

  tabs.forEach((element) => {
    element.classList.remove("is-open");
  });

  $this.classList.add("is-open");

  tabContents.forEach((element) => {
    if (element.getAttribute("id") === id) {
      element.classList.add("is-active");
    } else {
      element.classList.remove("is-active");
    }
  });
}

// Add the event listener
document.addEventListener("click", (event) => {
  if (event.target.matches(".custom-tab .tab-title")) {
    handleTabClick(event);
  }
});
